export default {
    controller: 'setPasswordEmailController',
    template: require('../views/email.setPassword.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/user/components/email.setPassword.component.js